import React from "react";
import { Icon, Breadcrumbs, Hidden } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  wrap: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: "10px 14px",
    borderRadius: 10,
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
  },
  pageTitle: {
    margin: "0 0 1px",
    paddingBottom: 1,
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "#0f172a",
    textTransform: "capitalize",
  },
  divider: {
    margin: "0 0 3px 8px",
    color: "#cbd5e1",
    fontWeight: 400,
  },
  crumb: {
    fontSize: "0.8rem",
    color: "#64748b",
    textTransform: "capitalize",
    textDecoration: "none",
    "&:hover": {
      color: "#0f172a",
    },
  },
  crumbActive: {
    fontSize: "0.8rem",
    color: "#94a3b8",
    textTransform: "capitalize",
  },
  homeIcon: {
    fontSize: 18,
    color: "#475569",
  },
}));

const Breadcrumb = ({ routeSegments }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrap}>
      {routeSegments ? (
        <Hidden xsDown>
          <h4 className={classes.pageTitle}>
            {routeSegments[routeSegments.length - 1]["name"]}
          </h4>
          <h4 className={classes.divider}>|</h4>
        </Hidden>
      ) : null}
      <Breadcrumbs
        separator={
          <Icon style={{ fontSize: 16, color: "#cbd5e1" }}>navigate_next</Icon>
        }
        className="flex items-center relative"
      >
        <NavLink to="/">
          <Icon className={`align-middle ml-1 mb-1 ${classes.homeIcon}`}>
            home
          </Icon>
        </NavLink>
        {routeSegments
          ? routeSegments.map((route, index) => {
              return index !== routeSegments.length - 1 ? (
                <NavLink key={index} to={route.path} className={classes.crumb}>
                  {route.name}
                </NavLink>
              ) : (
                <span key={index} className={classes.crumbActive}>
                  {route.name}
                </span>
              );
            })
          : null}
      </Breadcrumbs>
    </div>
  );
};

export default Breadcrumb;
